"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = migrateDeprecatedProps;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Say = _interopRequireDefault(require("./Say"));

var _SayButton = _interopRequireDefault(require("./SayButton"));

var _excluded = ["ponyfill", "speak", "speechSynthesis", "speechSynthesisUtterance", "text"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var warnings = {
  ponyfill: true,
  saySpeak: true
};

function migrateDeprecatedProps(_ref, componentType) {
  var ponyfill = _ref.ponyfill,
      speak = _ref.speak,
      speechSynthesis = _ref.speechSynthesis,
      speechSynthesisUtterance = _ref.speechSynthesisUtterance,
      text = _ref.text,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  if (!ponyfill && (speechSynthesis || speechSynthesisUtterance)) {
    if (warnings.ponyfill) {
      console.warn('react-say: "speechSynthesis" and "speechSynthesisUtterance" props has been renamed to "ponyfill". Please update your code. The deprecated props will be removed in version >= 3.0.0.');
      warnings.ponyfill = false;
    }

    ponyfill = {
      speechSynthesis: speechSynthesis,
      SpeechSynthesisUtterance: speechSynthesisUtterance
    };
  }

  if (componentType === _Say["default"] || componentType === _SayButton["default"]) {
    if (speak && !text) {
      if (warnings.saySpeak) {
        console.warn('react-say: "speak" prop has been renamed to "text". Please update your code. The deprecated props will be removed in version >= 3.0.0.');
        warnings.saySpeak = false;
      }

      text = speak;
    }
  }

  return _objectSpread({
    ponyfill: ponyfill,
    text: text
  }, otherProps);
}